import React from 'react';

const PanelTitle = ({ toggle, className, children, expanded, ...props }) => {
  return toggle ? (
    <div className={`panel-title ${className || ''}`} {...props}>
      <span
        aria-controls="accordion-uncontrolled-example-body-1"
        aria-expanded={expanded}
        className={expanded ? '' : 'collapsed'}
        role="button"
      >
        {children}
      </span>
    </div>
  ) : (
    <div className={`panel-title ${className || ''}`} {...props}>
      {children}
    </div>
  );
};

export default PanelTitle;
